<template>
  <v-dialog
    v-model="value"
    fullscreen
    hide-overlay
    transition="dialog-bottom-transition"
  >
    <v-toolbar
      dark
    >
      <v-btn
        @click="$router.back()"
      >
        {{ $t('storyHub.backToStoryHub') }}
      </v-btn>
    </v-toolbar>
    <TipTapEditor />
  </v-dialog>
</template>
<script>
  import TipTapEditor from '@/components/TipTapEditor';

  export default {
    name: 'EditDescriptionDialog',
    components:{
      TipTapEditor
    },
    props: {
      value: Boolean,
    },
    data () {
      return {
        notifications: false,
        sound: true,
        widgets: false,
      }
    },
  }
</script>